import {
  WKSDK,
  ChannelInfo,
  Channel,
  ChannelTypePerson,
  ChannelTypeGroup,
  Subscriber,
} from "wukongimjssdk"
import {
  messageChannelSync,
  channelsData,
  conversationSync,
  membersync,
} from '@/api/im.js'
import {
  Convert
} from "./convert";
import store from "../store";
import { getQueryString } from "../utils/location";



export function initDataSource() {
  // 同步自己业务端的频道消息列表
  WKSDK.shared().config.provider.syncMessagesCallback = async (channel, opts) => {
    console.log('获取消息列表')
    let messages = new Array()
    const resp = await messageChannelSync({
      "channel_id": channel.channelID,
      "channel_type": channel.channelType,
      "end_message_seq": opts.endMessageSeq,
      "limit": 30,
      "pull_mode": opts.pullMode,
      "start_message_seq": opts.startMessageSeq,
    })
    const messageList = resp.data && resp.data["messages"]
    // console.log(resp)
    if (messageList) {
      messageList.forEach((msg) => {
        const message = Convert.toMessage(msg);
        messages.push(message);
      });
    }

    return messages
  }

  // 同步自己业务端的最近会话列表
  WKSDK.shared().config.provider.syncConversationsCallback = async () => {
    console.log('获取最近会话列表')
    let conversations = new Array();

    try{
      let resp = await conversationSync({
        "msg_count": 1
      })
      if (resp.data) {
        resp.data.conversations.forEach((conversationMap) => {
          let model = Convert.toConversation(conversationMap);
          conversations.push(model);
        });
        const users = resp.data.users
        if (users && users.length > 0) {
          for (const user of users) {
            WKSDK.shared().channelManager.setChannleInfoForCache(Convert.userToChannelInfo(user))
          }
        }
        const groups = resp.data.groups
        if (groups && groups.length > 0) {
          for (const group of groups) {
            WKSDK.shared().channelManager.setChannleInfoForCache(Convert.groupToChannelInfo(group))
          }
        }
      }
      return conversations
    } catch(err){
      return conversations
    }
  }
  // 同步订阅者列表
  WKSDK.shared().config.provider.syncSubscribersCallback = async function(channel, version) {
    console.log('获取阅者列表')
    const resp = await membersync({
      'channel': channel,
      'version': version,
    });
    let members = [];
    if (resp.data) {
      for (let i = 0; i < resp.data.length; i++) {
        let memberMap = resp.data[i];
        let member = new Subscriber();
        member.uid = memberMap.uid;
        member.name = memberMap.name;
        member.remark = memberMap.remark;
        member.role = memberMap.role;
        member.version = memberMap.version;
        member.isDeleted = memberMap.is_deleted;
        member.status = memberMap.status;
        member.orgData = memberMap
        member.avatar = memberMap.avatar
        member.nickname = memberMap.nickname
        // member.avatar = WKApp.shared.avatarUser(member.uid)
        members.push(member);
      }
    }
    // members.sort((a, b) => {
    //   var roleA = a.role === GroupRole.owner ? 999 : a.role;
    //   var roleB = b.role === GroupRole.owner ? 999 : b.role;
    //   return roleB - roleA;
    // })
    
    return members;
  }

  // 获取频道信息
  WKSDK.shared().config.provider.channelInfoCallback = async function(channel) {
    console.log('获取频道信息')
    let channelInfo = new ChannelInfo()

    const res = await channelsData(channel)
    const data = res.data
    channelInfo.channel = new Channel(data.channel.channel_id, data.channel.channel_type);
    channelInfo.title = data.name;
    channelInfo.mute = data.mute === 1;
    channelInfo.top = data.stick === 1;
    channelInfo.online = data.online === 1;
    channelInfo.lastOffline = data.last_offline
    channelInfo.logo = data.logo
    if (!channelInfo.logo || channelInfo.logo === "") {
      if (channel.channelType === ChannelTypePerson) {
        channelInfo.logo = `users/${channel.channelID}/avatar`
      } else if (channel.channelType === ChannelTypeGroup) {
        channelInfo.logo = `groups/${channel.channelID}/avatar`
      }
    }

    channelInfo.orgData = data.extra || {};
    channelInfo.orgData.remark = data.remark ?? "";
    channelInfo.orgData.displayName = data.remark && data.remark !== "" ? data.remark : channelInfo.title;

    channelInfo.orgData.receipt = data.receipt;
    channelInfo.orgData.robot = data.robot;
    channelInfo.orgData.status = data.status;
    channelInfo.orgData.follow = data.follow;
    channelInfo.orgData.category = data.category;
    channelInfo.orgData.be_deleted = data.be_deleted;
    channelInfo.orgData.be_blacklist = data.be_blacklist;
    channelInfo.orgData.notice = data.notice;

    if (channel.channelType === ChannelTypePerson) {
      channelInfo.orgData.shortNo = data.extra.short_no ?? ""
    } else if (channel.channelType === ChannelTypeGroup) {
      channelInfo.orgData.forbidden = data.forbidden;
      channelInfo.orgData.invite = data.invite;
      channelInfo.orgData.forbiddenAddFriend = data.extra.forbidden_add_friend;
      channelInfo.orgData.save = data.save;
    }
    if (data.category === "system" || data.category === "customerService") { // 官方账号
      channelInfo.orgData.identityIcon = "./identity_icon/official.png"
      channelInfo.orgData.identitySize = {
        width: "18px",
        height: "18px"
      }
    } else if (data.category === "visitor") {
      channelInfo.orgData.identityIcon = "./identity_icon/visitor.png"
      channelInfo.orgData.identitySize = {
        width: "48px",
        height: "24px"
      }
    }
    return channelInfo
  }


  // 如果是群频道，可以实现这个方法，调用 WKSDK.shared().channelManager.syncSubscribes(channel) 方法将会触发此回调
  //  WKSDK.shared().config.provider.syncSubscribersCallback

  // 如果涉及到消息包含附件（多媒体）可以实现这个方法，sdk将调用此方法进行附件上传
  //  WKSDK.shared().config.provider.messageUploadTask


}